import { SupportedChainId } from './chains'

export const RPC_URLS: { [key in SupportedChainId]: string[] } = {
  [SupportedChainId.BEPOLIA]: ['https://bepolia.rpc.berachain.com'],
  [SupportedChainId.BERA]: import.meta.env.VITE_RPC_URLS_BERA
    ? import.meta.env.VITE_RPC_URLS_BERA.split(',')
    : ['https://rpc.kodiak.finance', 'https://rpc.berachain.com'],
  [SupportedChainId.ROBINHOOD]: import.meta.env.VITE_RPC_URLS_ROBINHOOD
    ? import.meta.env.VITE_RPC_URLS_ROBINHOOD.split(',')
    : ['https://rpc.mainnet.chain.robinhood.com', 'https://robinhood-rpc.publicnode.com'],
}

export function getRpcUrls(chainId: SupportedChainId): string[] {
  if (chainId in RPC_URLS) {
    return RPC_URLS[chainId]
  } else {
    throw new Error(`RPC URLs for chainId ${chainId} not found`)
  }
}
